import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=dea9a20e&scoped=true"
import script from "./PageView.vue?vue&type=script&lang=js"
export * from "./PageView.vue?vue&type=script&lang=js"
import style0 from "./PageView.vue?vue&type=style&index=0&id=dea9a20e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea9a20e",
  null
  
)

export default component.exports